module.exports = __webpack_public_path__ + "static/media/photo25.3b466687.jpg";